import React from 'react';
import cn from 'classnames';
import { Spinner } from '@cb/apricot-react-spinner';
export const LoadingWrapper = ({ children, loading, ariaLabel, light, overlayBackground = 'rgba(255, 255, 255, 0.3)', spinnerClassName, overflowX = true, positionRelative = true, maxHeight, }) => {
    return (React.createElement("div", { className: cn(positionRelative && 'position-relative'), style: { overflowX: overflowX ? 'hidden' : undefined, maxHeight: maxHeight ? `${maxHeight}px` : undefined } },
        loading && (React.createElement("div", { className: "cb-loader-wrapper", style: { background: overlayBackground } },
            React.createElement(Spinner, { light: light, ariaLabel: ariaLabel, className: spinnerClassName }))),
        children));
};
//# sourceMappingURL=LoadingWrapper.js.map